// src/index.tsx
import ReactDOM from 'react-dom/client';
import App from './App';
import { RouterProvider } from '@/utils/router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <RouterProvider>
    <App />
  </RouterProvider>
);
